import { useState, useEffect, useRef } from "react";
import Alert from "react-bootstrap/Alert";
import { Button, Modal } from "react-bootstrap";
import InputLebelComponent from "../../../InputLebel/InputLebelComponent";
import { AlertDanger, AlertSuccess } from "../../../Alerts/Alert";
import { useAuthContext } from "../../../../context/AuthContext";
import updateSummary from "../../../../apis/updateSummary";

const About = (props) => {
  const { userDetails } = useAuthContext();
  const current_user_slug = JSON.parse(userDetails).user_slug;

  const { bio, resourceSlug } = props;

  const statusRef = useRef(null);
  const executeScroll = () => statusRef.current.scrollIntoView();

  const [show, setShow] = useState(false);
  const [buttonText, setButtonText] = useState("Save");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [summary, setSummary] = useState("");
  const [localBio, setLocalBio] = useState("");

  const [hasSubmitError, setHasSubmitError] = useState(false);
  const [isValidSubmit, setIsValidSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  useEffect(() => {
    setSummary(bio);
    setLocalBio(bio);
  }, [bio]);

  const handleShow = () => setShow(true);

  const handleChange = (e) => {
    setSummary(e.target.value);
  };

  const handleFormSubmit = () => {
    setIsButtonDisabled(true);
    setButtonText("Processing, please wait...");
    setHasSubmitError(false);
    setErrorMessage(false);
    setIsValidSubmit(false);
    setSuccessMessage(false);

    let errMessage = [];

    if (summary.trim().length === 0) {
      errMessage.push("Enter summary");
      executeScroll();
      setErrorMessage(errMessage);
      setHasSubmitError(true);
      setIsButtonDisabled(false);
      setButtonText("Save");
      return;
    }

    submitForm();
  };

  const submitForm = () => {
    let errMessage = [];
    let succMessage = [];

    const formData = {
      current_user_slug,
      resourceSlug,
      summary,
    };

    try {
      updateSummary(formData).then(async (data) => {
        if (data?.data) {
          if (data.data.status === 1) {
            succMessage.push(data.data.message);
            setSuccessMessage(succMessage);
            setIsValidSubmit(true);
            setHasSubmitError(false);
            setLocalBio(summary); // Update local display bio
            setButtonText("Save");
            setTimeout(() => {
              setIsValidSubmit(false);
              setSuccessMessage(false);
              closeAddModal();
              setIsButtonDisabled(false);
            }, 1000);
          } else {
            errMessage.push(data.data.message);
            executeScroll();
            setErrorMessage(errMessage);
            setHasSubmitError(true);
            setIsButtonDisabled(false);
            setButtonText("Save");
          }
        } else {
          errMessage.push("Error happened. Unable to save information.");
          executeScroll();
          setErrorMessage(errMessage);
          setHasSubmitError(true);
          setIsButtonDisabled(false);
          setButtonText("Save");
        }
      });
    } catch (error) {
      errMessage.push("Error happened. Network error happened.");
      executeScroll();
      setErrorMessage(errMessage);
      setHasSubmitError(true);
      setIsButtonDisabled(false);
      setButtonText("Save");
    }
  };

  const displayProfileBio = () => {
    if (localBio?.trim()) {
      const profileBioFormatted = localBio.replace(/[?<>{}]/g, "•");
      return (
        <div className="card">
          <div className="card-body">
            <span className="p-wrap">{profileBioFormatted}</span>
          </div>
        </div>
      );
    } else {
      return (
        <Alert key={"info"} variant={"info"}>
          Profile bio not available!
        </Alert>
      );
    }
  };

  const displaySubmitButton = () => (
    <div className="d-block">
      <Button
        variant="primary"
        disabled={isButtonDisabled}
        onClick={handleFormSubmit}
        size="sm"
      >
        {buttonText}
      </Button>
    </div>
  );

  const displayCloseButton = () => (
    <div className="d-block me-3">
      <Button
        variant="dark"
        disabled={isButtonDisabled}
        onClick={closeAddModal}
        size="sm"
      >
        Close
      </Button>
    </div>
  );

  const closeAddModal = () => {
    setShow(false);
    setHasSubmitError(false);
    setIsValidSubmit(false);
    setErrorMessage(false);
    setSuccessMessage(false);
    setIsButtonDisabled(false);
    setButtonText("Save");
  };

  const handleClose = () => {
    setShow(false);
  };

  const displayStatusMessage = () => (
    <>
      {hasSubmitError && (
        <div className="d-block mt-4">
          <AlertDanger title={"Oops"} message={errorMessage} />
        </div>
      )}
      {isValidSubmit && (
        <div className="d-block mt-4">
          <AlertSuccess title={"Success"} message={successMessage} />
        </div>
      )}
    </>
  );

  const showModal = () => (
    <Modal
      show={show}
      onHide={handleClose}
      scrollable={true}
      backdrop="static"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <div className="d-block">
          <div className="d-block">
            <span className="h5 fw-bold-custom">
              Update your profile summary
            </span>
          </div>
          <div className="d-block">
            <span>Please complete the form to save your bio</span>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <form id="create-frm">
          <div className="d-block mb-4">
            <div className="col-12">
              <div className="form-input-holder">
                <InputLebelComponent title="Profile Summary" />
                <textarea
                  rows={6}
                  className="form-control"
                  id="summary"
                  placeholder="Enter summary"
                  onChange={handleChange}
                  value={summary}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        </form>
        <div className="d-flex justify-content-end">
          {displayCloseButton()}
          {displaySubmitButton()}
        </div>
        <div className="d-block" ref={statusRef}>
          {displayStatusMessage()}
        </div>
      </Modal.Body>
    </Modal>
  );

  const displayAddButton = () => (
    <div className="d-block justify-content-end">
      <Button variant="primary" size="sm" onClick={handleShow}>
        Update Profile Summary
      </Button>
    </div>
  );

  return (
    <div className="d-block">
      <div className="d-flex mb-2 justify-content-end">
        {displayAddButton()}
      </div>
      {displayProfileBio()}
      {showModal()}
    </div>
  );
};

export default About;
